module.exports = __webpack_public_path__ + "img/box-item-icon4.94ba6107.png";